import { apiMethodsConst } from '~/services/methods';
import { IReceiptReducerState, TReceiptAction } from './interface';
import { CLEAR_RECEIPTS_CSV_REPORT_V2 } from '~/actions';

export const initialState: IReceiptReducerState = {
  receipts: {
    data: [],
    metadata: {
      isFinal: false,
      limit: 0,
      officeIds: [],
      page: 0,
      sortBy: undefined,
      sortOrder: undefined,
      total: 0,
      transactionDate: '',
    },
  },
  reports: '',
};

const isSameOffices = (a: string[] = [], b: string[] = []) =>
  a.length === b.length && a.every((officeId, index) => officeId === b[index]);

export default (state = initialState, action: TReceiptAction): IReceiptReducerState => {
  const { type, payload } = action;

  switch (type) {
    case 'FETCH_RECEIPTS_V2_REQUEST': {
      // Rows for other offices go at once, so a location's page never shows the
      // previous location's while its own load (GOTU-19472).
      const isOtherOffices = !isSameOffices(state.receipts.metadata.officeIds, payload.officeId);

      return {
        ...state,
        receipts: {
          ...state.receipts,
          data: isOtherOffices ? [] : state.receipts.data,
          metadata: {
            ...state.receipts.metadata,
            limit: payload?.limit || 10,
            page: payload?.page || 1,
            officeIds: payload.officeId,
            sortBy: payload.sortBy,
            sortOrder: payload.sortOrder,
            transactionDate: payload.transactionDate,
          },
        },
      };
    }
    case apiMethodsConst.FETCH_RECEIPTS_V2_REQUEST: {
      const isFirstPage = payload?.page === 1;

      const receipts = isFirstPage
        ? payload.response
        : [...state.receipts.data, ...payload.response];

      const isFinal =
        payload.response.length === 0 ||
        payload.response.length < state.receipts.metadata.limit ||
        receipts.length === payload.total;

      return {
        ...state,
        receipts: {
          data: receipts,
          metadata: {
            ...state.receipts.metadata,
            total: payload.total,
            isFinal,
          },
        },
      };
    }
    case 'FETCH_RECEIPTS_V2_FAILURE': {
      // A failed first page leaves no rows rather than the ones from before it.
      if (state.receipts.metadata.page !== 1) return state;

      return {
        ...state,
        receipts: {
          data: [],
          metadata: { ...state.receipts.metadata, total: 0, isFinal: true },
        },
      };
    }
    case apiMethodsConst.FETCH_RECEIPTS_CSV_REPORT_V2_REQUEST: {
      return {
        ...state,
        reports: payload,
      };
    }
    case CLEAR_RECEIPTS_CSV_REPORT_V2: {
      return {
        ...state,
        reports: '',
      };
    }
    default: {
      return { ...state };
    }
  }
};
